<template>
  <router-view/>
</template>

<script>

export default {
  name: 'app'
}
</script>

<style lang="scss">
@import '~vis/dist/vis.css';
@import '~photonkit/dist/css/photon.css';

.clickable {
  cursor: pointer
}
</style>




// WEBPACK FOOTER //
// src/App.vue